export default __webpack_public_path__ + "static/media/checker3.34a62d86.jpg";